<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Rate plan name -->
    <rate-plan-name-field
      v-model="$attrs['rate-plan'].name"
      :error="$attrs.errors.rate_plan.name"
    />

    <!-- Amount -->
    <amount-field
      v-model="$attrs['rate-plan'].amount"
      :error="$attrs.errors.rate_plan.amount"
    />

    <!-- Period -->
    <period-field
      v-if="false"
      v-model="$attrs['rate-plan'].period"
      :error="$attrs.errors.rate_plan.period"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import ratePlanNameField from '@/components/forms/rate_plan/fields/RatePlanName'
import amountField from '@/components/forms/rate_plan/fields/Amount'
import periodField from '@/components/forms/rate_plan/fields/Period'
import startDateField from '@/components/forms/rate_plan/fields/StartDate'
import endDateField from '@/components/forms/rate_plan/fields/EndDate'

export default {
  name: 'rate-plan-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    ratePlanNameField,
    amountField,
    periodField,
    startDateField,
    endDateField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// RatePlanBlankForm.vue?c4313d52